<template>
<div class="d-flex justify-center align-center" style="height : 100vh;">
    <v-card :loading="loading" class="mx-auto box-shadow-custom" width="800">
        <v-row>
            <v-col cols="5" class="d-none d-sm-block">
                <v-card-text>
                    <v-img src="/images/verify.png" aspect-ratio="1" contain></v-img>
                </v-card-text>
            </v-col>
            <v-col cols="12" sm="7" md="7" class="pa-6 pb-0 d-flex align-center">
                <div style="width: 100%">
                    <v-card-text class="title text-center">
                        <h2>{{title}}</h2><br>
                    </v-card-text>
                    <v-card-text class="pt-0">
                        <v-btn color="primary" class="text-capitalize" block to="/">Back to home</v-btn>
                    </v-card-text>
                </div>
            </v-col>
        </v-row>
    </v-card>
</div>
</template>

<script>
import {
    mapActions,
    mapMutations
} from 'vuex'
export default {
    data: () => ({
        loading: true,
        title: 'Verifying your account, please wait.'
    }),
    methods: {
        ...mapActions(['GetResponse', 'PostResponse']),
        ...mapMutations(['SnackbarSuccess']),
        async initialize() {
            this.loading = true
            try {
                let url = `/internal/v2/check-verification/${this.$route.params.id1}/${this.$route.params.id2}`
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    try {
                        let value = {
                            url : '/internal/v2/verify',
                            data : { aid : this.$route.params.id1, uid: this.$route.params.id2}
                        }
                        const verification = (await this.PostResponse(value)).data
                        this.loading = false
                        let time = 5
                        var setTime = setInterval(() => { 
                            if (time > 0){
                                this.title = `Account is verified, redirecting you in ${--time} seconds...`
                            } else {
                                window.location = "https://offersoptimize.com"
                                clearInterval(setTime)
                            }
                        }, 1000)
                    } catch (err) {
                        let dataMsg = { success : true, message : err.response.data.errors[0].message, action : 'error' }
                        this.SnackbarSuccess(dataMsg)
                        this.loading = false
                    }
                }
            } catch (err) {
                let dataMsg = {
                    success: true,
                    message: err.response.data,
                    action: 'error'
                }
                this.title = `Invalid URL`
                this.SnackbarSuccess(dataMsg)
                this.loading = false
            }
        }
    },
    mounted() {
        this.initialize()
    }
}
</script>
